import React, { Component } from 'react';
import { Switch } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { metrics } from "react-metrics";

import config from "./metrics/metrics.config";
import getRoutes from './routes';
import ABTest from './abtest/components/abtest'
import ABTestRedirect from './abtest/components/abtest-redirect'
import ThirdPartyTags from './third-party-tags';
import IdleUser from './utility/components/idle-user';
import AboveTheFoldOnlyServerRender from './shared/components/above-the-fold-only-server-render';
import Namogoo from './shared/components/namogoo';
import UserInputUpdater from './ui/components/user-input-type';
import SiteConfig from './page/site-config.jsx'
import './App.less';
import '@hpstellar/global-styles/main.css';


class App extends Component {

    render() {
  		return (
        <div className={"App"} style={{zIndex: 1}}>
            <UserInputUpdater />
            <Switch>
                <ABTestRedirect>
                { 
                    ({abTestRedirects}) => {
                        //put ab test redirect routes before normal routes
                    return renderRoutes(abTestRedirects.concat(getRoutes()));
                    }
                }
                </ABTestRedirect>
            </Switch>
            <AboveTheFoldOnlyServerRender showTimeout={6000} skip={true}>
                {/*dont start tracking idle user until well after page load*/}
                <IdleUser />
            </AboveTheFoldOnlyServerRender>
            <ABTest experimentID="11073441806">
                { (data) =>{
                    return <Namogoo deploy={data.deploy} trackName={data.trackName} />
                }
                }
            </ABTest>
            <ThirdPartyTags/>
            <SiteConfig/>
        </div>
      );
    }
}

export default metrics(config, {useTrackBinding: false})(App);
